/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleALeftIcon24Solid = forwardRef('ArrowShapeTriangleALeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "m4.935 10.508 10.4-6.375C16.503 3.418 18 4.257 18 5.625v12.75c0 1.367-1.498 2.206-2.664 1.492L4.935 13.492a1.75 1.75 0 0 1 0-2.984Z" })));
});
